import { SxProps, typographyClasses, chipClasses } from '@mui/material'
import { filterChipClasses } from './FilterChip.data'

interface FilterChipStyles {
  chip: SxProps
}

export const filterChipStyles: FilterChipStyles = {
  chip: {
    width: 'fit-content',
    height: 32,

    [`& .${chipClasses.label} .${typographyClasses.root}`]: {
      paddingX: 0.5,
    },

    [`& .${chipClasses.deleteIcon}`]: {
      width: 12,
    },

    [`&:focus, &.${filterChipClasses.active}`]: {
      color: 'text.hyperLink',
      backgroundColor: 'brand.utility50',
      borderColor: 'utils.blue200',
      outline: 'none',

      [`& .${chipClasses.label} .${typographyClasses.root}`]: {
        color: 'text.hyperLink',
      },

      [`& .${chipClasses.deleteIcon}`]: {
        color: 'utils.blue300',
      },
    },
  },
}
